module.exports = "../../app/cells/components/payment_error_topbar_cell.rb";